module.exports = __webpack_public_path__ + "static/smoke-035b014b7d43ed2a9e09a907cdf69503.mp4";